import React, { useContext } from 'react'
import Modal from '@airbus/components-react/components/Modal'
import GoToTop from 'components/goToTop'
import Config from 'constants/config'
import LightDarkContext from 'context/LightDarkModeContext'
import DocumentPage from 'pages/Document/DocumentPage'

const ID_SCROLL_COMPONENT_FOR_GOTOTOP = 'modalViewDocumentGoToTop'

type Props = {
  title: string
  documentReference: string
  urlDocument: string
  isOpened: boolean
  onCloseModal: () => void
}

/**
 * Modal window which shows-up a document and its filename
 * @param {*} props
 * @returns
 */
const ModalViewDocument = ({ title, documentReference, urlDocument, isOpened, onCloseModal }: Props) => {
  const styleModal = {
    position: 'absolute',
    transform:
      'translate(calc((100% - ' + Config.MODAL_WIDTH + ') / 2), calc((100% - ' + Config.MODAL_HEIGHT + ') / 2))',
    width: Config.MODAL_WIDTH,
    height: Config.MODAL_HEIGHT,
    border: '2px solid #000',
    boxShadow: 24,
    overflowY: 'scroll',
    scrollbarWidth: 'none',
  }

  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <Modal
      open={isOpened}
      onClose={onCloseModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <div style={{ ...styleModal, backgroundColor: getBackgroundColor() }} id={ID_SCROLL_COMPONENT_FOR_GOTOTOP}>
        <DocumentPage
          title={title}
          documentReference={documentReference}
          urlDocument={urlDocument}
          modalEmbedded={true}
          onClose={onCloseModal}
        />

        <GoToTop idComponentForScroll={ID_SCROLL_COMPONENT_FOR_GOTOTOP} />
      </div>
    </Modal>
  )
}

export default ModalViewDocument
